/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkEnvironmentInfoDto } from '../models/work-environment-info-dto';

@Injectable({ providedIn: 'root' })
export class WorkEnvironmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `environmentV2ControllerGetEnvironmentInfo()` */
  static readonly EnvironmentV2ControllerGetEnvironmentInfoPath = '/v2/environment/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `environmentV2ControllerGetEnvironmentInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  environmentV2ControllerGetEnvironmentInfo$Response(
    params?: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEnvironmentInfoDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEnvironmentService.EnvironmentV2ControllerGetEnvironmentInfoPath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEnvironmentInfoDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `environmentV2ControllerGetEnvironmentInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  environmentV2ControllerGetEnvironmentInfo(
    params?: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkEnvironmentInfoDto> {
    return this.environmentV2ControllerGetEnvironmentInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEnvironmentInfoDto>): WorkEnvironmentInfoDto => r.body)
    );
  }

}
